import React from 'react';
import Search from './Search';
import { StyledFilter } from './index.style';
import AdvancedFilterButton from './AdvancedFilterButton';
import SortVoice from './SortVoice';

const Toolbar = ({
  searchValueView,
  setSearchValueView,
  setOpenFilter,
  setDataFilter,
  isFiltering,
  setOpenSort,
  hasSort,
}) => (
  <StyledFilter hasSort={hasSort}>
    <Search
      searchValueView={searchValueView}
      setSearchValueView={setSearchValueView}
      setDataFilter={setDataFilter}
    />
    <AdvancedFilterButton
      setOpenFilter={setOpenFilter}
      isFiltering={isFiltering}
    />
    <SortVoice setOpenSort={setOpenSort} hasSort={hasSort} />
  </StyledFilter>
);

export default Toolbar;
